import {
  faWater,
  faWaterArrowDown,
  faWaterArrowUp,
} from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';

export const TREND_RISING = 'rising';
export const TREND_FALLING = 'falling';
export const TREND_STEADY = 'steady';

export const getTrendLabel = (t, trend) => {
  if (trend === undefined) {
    return undefined;
  }

  return t(`dataTrends.${trend}.label`);
}

export const getTrendDescription = (t, trend, trendHours) => {
  if (trend === undefined) {
    return undefined;
  }

  return t(`dataTrends.${trend}.description`, {count: trendHours});
}

export const getTrendIcon = (trend) => {
  switch(trend) {
    case TREND_RISING:
      return faWaterArrowUp;
    case TREND_FALLING:
      return faWaterArrowDown;
    case TREND_STEADY:
      return faWater;
    default:
      return undefined;
  }
}

